module.exports = __webpack_public_path__ + "images/district_back.1789608252531.png";